import {combineReducers} from '@reduxjs/toolkit';

import {assignProductAccountEntitlementsStateSlice} from './slices/assign-product-account-entitlements-state.slice';
import {assignProductAccountEntitlementsDataSlice} from './slices/assign-product-account-entitlements.slice';

export const assignProductAccountEntitlementsReducer = combineReducers({
    result: assignProductAccountEntitlementsDataSlice.reducer,
    state: assignProductAccountEntitlementsStateSlice.reducer,
});
